import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import { detailsSetData } from 'Checkout/Redux/Actions/Details'
import { searchFilterUpdate } from 'Checkout/Redux/Actions/Search'
import initialState from 'Checkout/Redux/InitialState'
import ratesQuery from 'Checkout/Queries/RatesQuery'

export const useRatesQuery = () => {
  const dispatch = useDispatch()
  const [getRates, { data, loading, error }] = useLazyQueryNoCache(ratesQuery)
  const { editingReservationId, reservations } = useSelector(state => state.cart)
  const currentRateSelected = useSelector(state => state.search.rate?.id)
  const productsPurchased = useSelector(state => state.details.productsPurchased)
  const rates = data?.campground?.ratesAvailableDuring || []
  const rateSelected = rates.find(rate => rate.id === currentRateSelected)
  const isRvSite = useSelector(state => state.search?.siteType?.type) === 'type_rv_site'

  const buildExceptions = () => {
    const reservationsToBuild = reservations.filter(res => res.nanoId !== editingReservationId)

    return reservationsToBuild.map(({ data, from, to }) => ({
      from,
      rateId: data.rate.id,
      to,
    }))
  }

  const getSavedAddon = (addon, items) => items.find(product => parseInt(product.id) === parseInt(addon.id))

  const mixProducts = addons => {
    const newProducts = productsPurchased.filter(currentProduct => {
      const savedAddon = getSavedAddon(currentProduct, addons)
      return currentProduct.id === parseInt(savedAddon?.id)
    })

    dispatch(detailsSetData({ productsPurchased: newProducts }))
  }

  const handleGetRates = data => {
    const exceptions = buildExceptions()
    const variables = { ...data, editingReservation: !!editingReservationId, exceptions,
                        productFilters: { sources: ['online'] } }

    getRates({ variables })
  }

  useEffect(() => {
    if (editingReservationId && !loading) {
      const { addons } = rateSelected || {}

      if (addons) mixProducts(addons)
      if (!isRvSite) dispatch(detailsSetData({ vehicle: initialState.details.vehicle }))
      dispatch(searchFilterUpdate({ newRateNeeded: !rateSelected }))
    }
  }, [rateSelected?.id, rates.length])

  return [handleGetRates, { error, loading, rateSelected, rates }]
}
